<template>
  <v-dialog v-model="modal" fullscreen hide-overlay transition="dialog-bottom-transition" persistent>
    <v-card>
      <div class="align-v-center cover-bg">
        <v-container grid-list-md text-xs-center>
          <v-layout align-center justify-center row>
            <v-flex sm12 md12>
              <v-card class="elevation-12 pb-4 mt-8">
                <v-card-title class="primary text-white">
                  ACCOUNTS
                  <v-spacer></v-spacer>
                  <v-btn
                    small
                    slot="action"
                    @click=logout()
                    fab
                    color="white"
                    :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-0' : 'ml-0'"
                  >
                    <v-icon dark class="primary--text">fas fa-sign-out-alt</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-subtitle class="primary white--text">
                    Select the account that you would like to access
                </v-card-subtitle>

                <div class="px-4 mx-1 mt-7 pt-7" v-if="userAcounts.length == 0">
                  <p>Sorry you dont have any associated business. Please contact support.</p>
                </div>
                <div class="px-4 mx-1 mt-7 pt-7" v-else>
                  <v-layout row wrap justify-space-between>
                    <v-flex
                      px-4
                      sm12
                      xs12
                      md6
                      lg6
                      v-bind:key="index"
                      v-for="(account, index) in userAcounts"
                    >
                      <v-card
                        hover
                        class="elevation-12 mb-4 pointer account-list"
                        v-on:click.prevent="setActiveBusiness(account.id)"
                      >
                        <div class="c-layout">
                          <div class="cl-flex6">
                            <div class="min-h-80 v-center bg-grey">
                              <img src="@/assets/images/uno-logo.png" class="account-logo" />
                            </div>
                          </div>
                          <div class="cl-flex6">
                            <div class="min-h-80 section-excerpt v-center">
                              <h2 class="font-weight-bold title">{{ account.name }}</h2>
                            </div>
                          </div>
                        </div>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import AuthApi from '@/controllers/AuthApis'

export default {
  data: () => {
    return {}
  },
  mounted () {

  },
  computed: {
    modal () {
      if (this.$store.getters['auth/user'].token && this.$route.name === 'Login') {
        return true
      }
      return this.$root.selectBusinessModal
    },
    ...mapGetters({
      userAcounts: 'business/businessList',
      branding: 'business/activeBusinessBranding'
    })
  },
  methods: {
    async setActiveBusiness (id) {
      this.spinner(true)
      await AuthApi.setActiveBusiness(id)
        .then(async (res) => {
          // when successfully set active business
          if (res) {
            await this.$store.dispatch('business/getBusinessBranding', id) // fetch branding
            // set branding theme
            if (this.branding) {
              this.$vuetify.theme.themes.light.primary = this.branding.primary_color
              this.$vuetify.theme.themes.light.secondary = this.branding.secondary_color
              this.$vuetify.theme.themes.light.accent = this.branding.accent_color
            }

            this.$root.selectBusinessModal = false
            this.spinner(false)

            this.snackbar({ text: 'Successfully logged in' })
            // Push to the home
            this.$router.push('/locations')
          } else {
            this.snackbar({ text: 'Login failed' })
            this.spinner(false)
          }
        })
    },

    async logout () {
      try {
        this.$root.selectBusinessModal = false
        await this.$store.dispatch('auth/logout')
        this.$store.commit('auth/SET_USER', '')
        this.snackbar({ text: 'Successfully logged out' })
      } catch (e) {
        this.$store.commit('auth/SET_USER', '')
      }
    }
  }
}
</script>
